import { mergeWith } from 'lodash';

/**
 * Conditionally add elements inside Array literals
 *
 * @example
 *
 * const arr = [
 *   ...insertIf(cond, 'a'),
 *   'b',
 * ];
 *
 * @param {boolean} condition
 * @param {...any} elements
 */
export function insertIf(condition, ...elements) {
  return condition ? elements : [];
}

/**
 * Merge head tags into one object
 *
 * @param {...Object} args
 */
export function mergeHeadItems(...args) {
  const customizerMergeArrays = (objValue, srcValue) => {
    if (Array.isArray(objValue)) {
      return objValue.concat(srcValue);
    }
  };
  return mergeWith({}, ...args, customizerMergeArrays);
}

/**
 * Opens external popup
 * @param {string} url
 */
export const openExternalPopup = (url) => {
  window.open(url, 'popup', 'width=600,height=600,scrollbars=no,resizable=no');
  return false;
};

/**
 * Create an interval for active tab
 * @param {function} callback
 * @param {number} delay
 */
export const activeTabInterval = (callback, delay) => {
  let interval = setInterval(callback, delay);
  function checkVisibility() {
    if (document.visibilityState === 'hidden') {
      clearInterval(interval);
    } else {
      interval = setInterval(callback, delay);
    }
  }
  document.addEventListener('visibilitychange', checkVisibility);
  return {
    clear() {
      document.removeEventListener('visibilitychange', checkVisibility);
      clearInterval(interval);
    },
  };
};

/**
 * Some 3rd party libraries break the body classes
 * This function reloads body classes
 */
export const bodyClassFixer = () => {
  if (process.client) {
    if (document.body.classList.contains('no-scroll')) {
      document.body.classList.remove('no-scroll');
    }
    const cList = JSON.parse(JSON.stringify(document.body.classList));
    setTimeout(() => {
      document.body.classList.add(...Object.values(cList));
    }, 200);
  }
};
